import React from "react";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import useAppTheme from "./hooks/useAppTheme";

function AppThemeBaseLine({ children }) {
  const [theme] = useAppTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default AppThemeBaseLine;
